module.exports = __webpack_public_path__ + "img/exe.b36ffdf3.png";